<template>
  <div class="mb-4">
    <Chart :options="chartOptions" />
    <div class="mt-1 p-4">
      <p class="pt-1 pb-1" >{{ data.note }}</p>
      <p class="pt-1 pb-1" >{{ data.message }}</p>
    </div>
  </div>
</template>
<script setup lang="ts">
import { defineProps, computed } from "vue";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import accessibilityInit from "highcharts/modules/accessibility"; // Import the accessibility module
import exportingInit from "highcharts/modules/exporting";
import heatmapInit from "highcharts/modules/heatmap"; // Import the heatmap module

// Initialize the accessibility module
accessibilityInit(Highcharts);
// Initialize the exporting module
exportingInit(Highcharts);
// Initialize the heatmap module
heatmapInit(Highcharts);

const props = defineProps(["data"]);

// Determine the range of x-axis and y-axis values
const xAxisCategories = [...new Set(props.data.heatMap.map((item) => item.x))];
const yAxisCategories = [...new Set(props.data.heatMap.map((item) => item.y))];
// Create a two-dimensional array for the heatmap data
const heatmapData = xAxisCategories.map((x, xIndex) => {
  return yAxisCategories.map((y, yIndex) => {
    const dataPoint = props.data.heatMap.find((item) => item.x === x && item.y === y);
    return dataPoint ? [xIndex, yIndex, dataPoint.value] : [xIndex, yIndex, null];
  });
});
// Flatten the arrays to create a single array for all data points
const flattenedHeatmapData = [].concat(...heatmapData);

/// Calculate the min and max values from your heatmapData
const min = Math.min(...props.data.heatMap.map((item) => item.value));
const max = Math.max(...props.data.heatMap.map((item) => item.value));

const chartOptions = {
  chart: {
    type: "heatmap",
  },
  title: {
    text: "Minimum Selling Price €",
  },
  xAxis: {
    categories: xAxisCategories,
    reversed: true,
    title: {
      text: props.data.x, // Title for the y-axis
    },
  },
  yAxis: {
    categories: yAxisCategories,
    title: {
      text: props.data.y, // Title for the y-axis
    },
    reversed: false,
  },
  colorAxis: {
    min: min,
    max: max, // Adjust min and max based on your data
    minColor: "#FFFFFF",
    maxColor: Highcharts.getOptions().colors[7],
    reversed: true,
  },
  legend: {
    align: "right",
    layout: "vertical",
    // margin: 0,
    verticalAlign: "middle",
    // y: 50,
    // symbolHeight: 280,
  },
  tooltip: {
    format: "Minimum Selling Price<br/>[{series.xAxis.categories.(point.x)} , {series.yAxis.categories.(point.y)}] : <b>{point.value} €</b>",
  },
  series: [
    {
      name: "Minimum Selling Price €",
      borderWidth: 1,
      data: flattenedHeatmapData,
      dataLabels: {
        enabled: true,
        color: "#000000",
      },
    },
  ],
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 500,
        },
        chartOptions: {
          yAxis: {
            labels: {
              format: "{substr value 0 1}",
            },
          },
        },
      },
    ],
  },
  exporting: {
    enabled: true,
  },
};
</script>
